function unflatten ( flatCharData, dataSchema = 0.5 ) {

    // takes flatCharData and repacks into charData according to the specified dataSchema

    let N = {}; // charData dictionary

    let F = flatCharData;

    if ( dataSchema >= 0.3 ) {


            N = { abilities: {}, armor:{}, chars:{}, items:{}, magic:{}, potions:{}, followers: {}, saves:{}, spells:{}, stats:{}, weapons:{} }
            
            N.name = F.name  || "";
            N.campaign = F.campaign || "";
            // N.version = dataSchema.toString();

            N.abilities.myAbi = F.myAbi || "";
            N.abilities.myRabi = F.myRabi || "";

            N.armor.myBaseAC = F.myBaseAC || "";
            N.armor.myArm1 = F.myArm1 || "";
            N.armor.myArm2 = F.myArm2 || "";
            N.armor.myArm3 = F.myArm3 || "";
            N.armor.myArm4 = F.myArm4 || "";
            N.armor.myArm5 = F.myArm5 || "";
            N.armor.myAb1 = F.myAb1 || "";
            N.armor.myAb2 = F.myAb2 || "";
            N.armor.myAb3 = F.myAb3 || "";
            N.armor.myAb4 = F.myAb4 || "";
            N.armor.myAb5 = F.myAb5 || "";

            N.chars.myAC = F.myAC || "";
            N.chars.myAlign = F.myAlign || "";
            N.chars.myClass = F.myClass || "";
            N.chars.myDeity = F.myDeity || "";
            N.chars.myGold = F.myGold || "";
            N.chars.myHei = F.myHei || "";
            N.chars.myWei = F.myWei || "";
            N.chars.myAge = F.myAge || ""; // v0.4
            N.chars.myHPbase = F.myHPbase || "";
            N.chars.myHPcurr = F.myHPcurr || "";
            N.chars.myHPnote = F.myHPnote || "";
            N.chars.myLevel = F.myLevel || "";
            N.chars.myMov = F.myMov || "";
            N.chars.myNatt = F.myNatt || "";
            N.chars.myRace = F.myRace || "";
            N.chars.myRear = F.myRear || "";
            N.chars.mySide = F.mySide || "";
            N.chars.myToHit = F.myToHit || "";
            N.chars.myXP = F.myXP || "";
            N.chars.myXPbonus = F.myXPbonus || "";
            N.chars.myXPnext = F.myXPnext || "";

            N.items.myOth1 = F.myOth1 || "";   
            N.items.myOth2 = F.myOth2 || "";
            N.items.myOth3 = F.myOth3 || "";
            N.items.myOth4 = F.myOth4 || "";
            N.items.myOth5 = F.myOth5 || "";
            N.items.myOth6 = F.myOth6 || ""; // v0.4
            N.items.myOth7 = F.myOth7 || ""; // v0.4

            N.magic.myMag1 = F.myMag1 || "";   
            N.magic.myMag2 = F.myMag2 || "";
            N.magic.myMag3 = F.myMag3 || "";
            N.magic.myMag4 = F.myMag4 || "";
            N.magic.myMag5 = F.myMag5 || "";

            N.potions.myPot1 = F.myPot1 || "";   N.potions.myQpo1 = F.myQpo1 || "";
            N.potions.myPot2 = F.myPot2 || "";   N.potions.myQpo2 = F.myQpo2 || "";
            N.potions.myPot3 = F.myPot3 || "";   N.potions.myQpo3 = F.myQpo3 || "";
            N.potions.myPot4 = F.myPot4 || "";   N.potions.myQpo4 = F.myQpo4 || "";
            N.potions.myPot5 = F.myPot5 || "";   N.potions.myQpo5 = F.myQpo5 || "";
            N.potions.myPot6 = F.myPot6 || "";   N.potions.myQpo6 = F.myQpo6 || "";
            
            N.followers.myFol1 = F.myFol1 || ""; 
            N.followers.myFol2 = F.myFol2 || "";

            N.saves.mySav1 = F.mySav1 || "";   
            N.saves.mySav2 = F.mySav2 || "";
            N.saves.mySav3 = F.mySav3 || "";
            N.saves.mySav4 = F.mySav4 || "";
            N.saves.mySav5 = F.mySav5 || "";
            N.saves.mySbon1 = F.mySbon1 || "";   
            N.saves.mySbon2 = F.mySbon2 || "";
            N.saves.mySbon3 = F.mySbon3 || "";
            N.saves.mySbon4 = F.mySbon4 || "";
            N.saves.mySbon5 = F.mySbon5 || "";
            N.saves.mySbon6 = F.mySbon6 || "";
            N.saves.mySbon7 = F.mySbon7 || "";

            // v0.4 spell loading
            /*
            for (let i = 11; i <= 99; i++) {
            N.spells[`mySp${i}`] = F[`mySp${i}`] || "";
            N.spells[`mySpk${i}`] = F[`mySpk${i}`] || ['Empty','Empty','Empty','Empty','Empty','Empty'];
            }
            */

            // v0.5 spell loading
            for (let i = 1; i <= 9; i++) {
                for ( let j=1; j<=30; j++ ) {
                    const jstr = j.toString().padStart(2, '0');
                    N.spells[`mySp${i}${jstr}`] = F[`mySp${i}${jstr}`] || "";
                    N.spells[`mySpk${i}${jstr}`] = F[`mySpk${i}${jstr}`] || ['Empty','Empty','Empty','Empty','Empty','Empty'];
                }
            }

            N.spells.myTsp1 = F.myTsp1 || "";   N.spells.myNsp1 = F.myNsp1 || "";
            N.spells.myTsp2 = F.myTsp2 || "";   N.spells.myNsp2 = F.myNsp2 || "";
            N.spells.myTsp3 = F.myTsp3 || "";   N.spells.myNsp3 = F.myNsp3 || "";
            N.spells.myTsp4 = F.myTsp4 || "";   N.spells.myNsp4 = F.myNsp4 || "";
            N.spells.myTsp5 = F.myTsp5 || "";   N.spells.myNsp5 = F.myNsp5 || "";

            N.stats.myStr = F.myStr
            N.stats.myInt = F.myInt
            N.stats.myWis = F.myWis
            N.stats.myDex = F.myDex
            N.stats.myCon = F.myCon
            N.stats.myCha = F.myCha

            N.stats.myStrBon = F.myStrBon
            N.stats.myIntBon = F.myIntBon
            N.stats.myWisBon = F.myWisBon
            N.stats.myDexBon = F.myDexBon
            N.stats.myConBon = F.myConBon
            N.stats.myChaBon = F.myChaBon

            N.weapons.myWeap1 = F.myWeap1
            N.weapons.myWeap2 = F.myWeap2
            N.weapons.myWeap3 = F.myWeap3
            N.weapons.myWeap4 = F.myWeap4
            N.weapons.myWeap5 = F.myWeap5

            N.weapons.myWth1 = F.myWth1
            N.weapons.myWth2 = F.myWth2
            N.weapons.myWth3 = F.myWth3
            N.weapons.myWth4 = F.myWth4
            N.weapons.myWth5 = F.myWth5

            N.weapons.myWdb1 = F.myWdb1
            N.weapons.myWdb2 = F.myWdb2
            N.weapons.myWdb3 = F.myWdb3
            N.weapons.myWdb4 = F.myWdb4
            N.weapons.myWdb5 = F.myWdb5

            N.weapons.myWdmg1 = F.myWdmg1
            N.weapons.myWdmg2 = F.myWdmg2
            N.weapons.myWdmg3 = F.myWdmg3
            N.weapons.myWdmg4 = F.myWdmg4
            N.weapons.myWdmg5 = F.myWdmg5
        

    }

    if ( dataSchema >= 0.4 ) {
        // add code for spellCheckData
    }

    if ( dataSchema >= 0.5 ) {
            if (F.myWeap6) N.weapons.myWeap6 = F.myWeap6
            if (F.myWth6) N.weapons.myWth6 = F.myWth6
            if (F.myWdb6) N.weapons.myWdb6 = F.myWdb6
            if (F.myWdmg6) N.weapons.myWdmg6 = F.myWdmg6
            if (F.myArm6) N.armor.myArm6 = F.myArm6 || "";
            if (F.myAb6) N.armor.myAb6 = F.myAb6 || "";
            if (F.myMag6) N.magic.myMag6 = F.myMag6 || "";

            if (F.myWeap7) N.weapons.myWeap7 = F.myWeap7
            if (F.myWth7) N.weapons.myWth7 = F.myWth7
            if (F.myWdb7) N.weapons.myWdb7 = F.myWdb7
            if (F.myWdmg7) N.weapons.myWdmg7 = F.myWdmg7
            if (F.myArm7) N.armor.myArm7 = F.myArm7 || "";
            if (F.myAb7) N.armor.myAb7 = F.myAb7 || "";
            if (F.myMag7) N.magic.myMag7 = F.myMag7 || "";

            if (F.myWeap8) N.weapons.myWeap8 = F.myWeap8
            if (F.myWth8) N.weapons.myWth8 = F.myWth8
            if (F.myWdb8) N.weapons.myWdb8 = F.myWdb8
            if (F.myWdmg8) N.weapons.myWdmg8 = F.myWdmg8
            if (F.myArm8) N.armor.myArm8 = F.myArm8 || "";
            if (F.myAb8) N.armor.myAb8 = F.myAb8 || "";
            if (F.myMag8) N.magic.myMag8 = F.myMag8 || "";

            if (F.myWeap9) N.weapons.myWeap9 = F.myWeap9
            if (F.myWth9) N.weapons.myWth9 = F.myWth9
            if (F.myWdb9) N.weapons.myWdb9 = F.myWdb9
            if (F.myWdmg9) N.weapons.myWdmg9 = F.myWdmg9
            if (F.myArm9) N.armor.myArm9 = F.myArm9 || "";
            if (F.myAb9) N.armor.myAb9 = F.myAb9 || "";
            if (F.myMag9) N.magic.myMag9 = F.myMag9 || "";

            if (F.myWeap10) N.weapons.myWeap10 = F.myWeap10
            if (F.myWth10) N.weapons.myWth10 = F.myWth10
            if (F.myWdb10) N.weapons.myWdb10 = F.myWdb10
            if (F.myWdmg10) N.weapons.myWdmg10 = F.myWdmg10
            if (F.myArm10) N.armor.myArm10 = F.myArm10 || "";
            if (F.myAb10) N.armor.myAb10 = F.myAb10 || "";
            if (F.myMag10) N.magic.myMag10 = F.myMag10 || "";



    }

    return N


}

export default unflatten